import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import ObjectRegisteryTable from "../../apiTables/ObjectRegisteryTable";

const ToUserCaseTablePage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar/>
                    <ObjectRegisteryTable/>
                </div>
            </div>
        </div>
    );
};

export default ToUserCaseTablePage;
